import React from 'react';
import styled from 'styled-components';
import tw from 'twin.macro';
import SteeringWheel from '../SteeringWheel';
import { Colors } from '../../styles/colors';

const Overlay = styled.div`
  ${tw`
    fixed
    inset-0
    flex
    flex-col
    items-center
    justify-center
    z-50
  `}
  background-color: rgba(0, 0, 0, 0.5);
`;

const Content = styled.div`
  ${tw`
    bg-white
    rounded-card
    p-8
    flex
    flex-col
    items-center
    gap-4
    shadow-overlay
  `}
  min-width: 280px;
`;

const Message = styled.div`
  ${tw`
    text-text-secondary
    font-medium
    text-center
  `}
`;

const Subtext = styled.div`
  ${tw`
    text-text-secondary
    text-sm
    text-center
  `}
`;

export interface LoadingOverlayProps {
  /** Whether the overlay is visible */
  isOpen: boolean;
  /** Main loading message */
  message?: string;
  /** Optional subtext below the message */
  subtext?: string;
  /** Color of the steering wheel icon */
  color?: string;
  /** Size of the steering wheel icon */
  iconSize?: number;
  /** Whether the steering wheel should rotate */
  rotating?: boolean;
}

const LoadingOverlay: React.FC<LoadingOverlayProps> = ({
  isOpen,
  message = 'Processing...',
  subtext,
  color = Colors.Black,
  iconSize = 60,
  rotating = true,
}) => {
  if (!isOpen) return null;

  return (
    <Overlay>
      <Content>
        <SteeringWheel size={iconSize} rotating={rotating} color={color} />
        <Message>{message}</Message>
        {subtext && <Subtext>{subtext}</Subtext>}
      </Content>
    </Overlay>
  );
};

export default LoadingOverlay;
